/** @format */

export default {
	methods: {
		/**
		 * @description 组件属性默认值
		 */
		handleAttribute(attribute, defaultValue) {
			if (attribute === false || attribute === 0 || attribute === '') {
				return attribute;
			}
			return attribute || defaultValue;
		},
	},
};
